'use client';

import { useAuth0CreateAccountEvent } from '../../hooks/useAuth0CreateAccountEvent';
import { useAuth0LoginEvent } from '../../hooks/useAuth0LoginEvent';

/**
 * Mounted globally from `PageLayout` because Auth0 authentication finishes on a fixed
 * callback route and then navigates on, so no single feature owns the moment the shopper
 * returns. Renders nothing. Login and create-account events each no-op unless their
 * own completed-authentication or new-registration signal is present.
 */
export function Auth0AnalyticsTracker() {
    useAuth0CreateAccountEvent();
    useAuth0LoginEvent();

    return null;
}
